var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createTheme } from '@mui/material';
import { merge } from 'lodash';
var themeOptions = {
    typography: {
        fontFamily: 'Poppins',
    },
    components: {
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    borderRadius: 4,
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    minWidth: 250,
                    '& .MuiFilledInput-root': {
                        '&::before': {
                            content: 'none',
                        },
                        '&::after': {
                            content: 'none',
                        },
                    },
                    '& .MuiFilledInput-input': {
                        paddingTop: 9,
                        paddingLeft: 12,
                        paddingBottom: 10,
                        paddingRight: 12,
                    },
                },
            },
            defaultProps: {
                variant: 'filled',
                size: 'small',
                hiddenLabel: true,
                InputProps: {
                    disableUnderline: true,
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                inputRoot: {
                    '&.MuiFilledInput-root.MuiInputBase-sizeSmall': {
                        paddingTop: 1,
                        paddingLeft: 12,
                        paddingBottom: 1,
                    },
                    '&.MuiFilledInput-root.MuiInputBase-sizeSmall .MuiFilledInput-input': {
                        padding: '8.5px 0px',
                    },
                },
                popper: {
                    '& .MuiPaper-root': {
                        boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
                    },
                },
            },
            defaultProps: {},
        },
        MuiSelect: {
            defaultProps: {
                variant: 'filled',
                size: 'small',
                disableUnderline: true,
            },
            styleOverrides: {
                select: {
                    '&.MuiFilledInput-input': {
                        '&::before': {
                            content: 'none',
                        },
                        '&::after': {
                            content: 'none',
                        },
                        paddingTop: 9,
                        paddingLeft: 12,
                        paddingBottom: 10,
                        paddingRight: 12,
                    },
                },
            },
        },
        MuiButton: {
            defaultProps: { variant: 'contained' },
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none',
                    },
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                scroller: {
                    '&::after': {
                        content: '" "',
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        height: '1px',
                        display: 'block',
                    },
                },
            },
        },
        MuiPaper: {
            defaultProps: {
                elevation: 0,
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                },
            },
            defaultProps: {
                elevation: 0,
            },
        },
        MuiGrid: {
            styleOverrides: {
                container: {
                    width: 'calc(100% + 17px)',
                },
            },
            defaultProps: {
                spacing: 2,
            },
        },
        MuiTooltip: {
            defaultProps: {
                PopperProps: {
                    disablePortal: true,
                },
            },
        },
    },
};
export var lightTheme = createTheme(merge({}, themeOptions, {
    palette: __assign({ primary: {
            main: '#ff781d',
        }, text: {
            primary: '#252c32',
        }, background: {
            default: '#ffffff',
            paper: '#f9fbfc',
        } }, { border: '#f5f5f5' }),
    components: {
        MuiButton: {
            styleOverrides: {
                contained: {
                    color: '#ffffff',
                },
            },
        },
        MuiFilledInput: {
            styleOverrides: { root: { backgroundColor: '#f9fbfc' } },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    '& .MuiFilledInput-root': {
                        backgroundColor: 'rgba(0, 0, 0, 0.06)',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.09)',
                        },
                    },
                },
            },
        },
    },
}));
export var darkTheme = createTheme(merge({}, themeOptions, {
    palette: __assign({ mode: 'dark', primary: {
            main: '#ff781d',
        }, background: {
            paper: '#1e1e1e',
        } }, { border: '#242424' }),
    components: {
        MuiCssBaseline: {
            styleOverrides: "\n          img.themed-svg {\n            filter: invert(1);\n          }\n        ",
        },
        MuiFilledInput: {
            styleOverrides: { root: { backgroundColor: '#1e1e1e' } },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    '& .MuiFilledInput-root': {
                        backgroundColor: 'rgba(255, 255, 255, 0.06)',
                        '&:hover': {
                            backgroundColor: 'rgba(255, 255, 255, 0.09)',
                        },
                    },
                },
            },
        },
    },
}));
